import * as React from "react";
import { ChangeEvent, useState, useEffect, useContext } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import NewIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import KeyIcon from '@mui/icons-material/Key';
import EraseIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@mui/material/IconButton"
import Usuario from "../../components/classes/Usuario";
import Regra from "../../components/classes/Regra";
import GroupIcon from '@mui/icons-material/Group';
import UsuarioDataSet from "../../components/data/UsuarioDataSet";
import { UsuarioTopo } from "./topo";
import SelRegras from "../regras/components/SelRegras";
import { UserContext } from "../../App";
import { confirmAlert } from "react-confirm-alert";
import { MenuItem } from "@mui/material";
import ParceiroDataset from "../../components/data/parceiroDataset";
import Parceiro from "../../components/classes/Parceiro";
import ParceiroModal from "./ParceiroModal";
import { useTranslation } from "react-i18next";

export const UsuarioDetalhe = () => {
  const { t } = useTranslation();
  const user: any = useContext(UserContext);

  const usuarioDataSet = new UsuarioDataSet();
  const parceiroDataSet = new ParceiroDataset();

  const [nomeUsuario, setNomeUsuario] = useState<string>('');
  const [emailUsuario, setEmailUsuario] = useState<string>('');
  const [telefoneUsuario, setTelefoneUsuario] = useState<string>('');
  const [senhaUsuario, setSenhaUsuario] = useState<string>('***');
  const [perfilUsuario, setPerfilUsuario] = useState<number>(1);
  const [falhasUsuario, setFalhasfoneUsuario] = useState<number>(0);
  const [bloqueioUsuario, setBloqueioUsuario] = useState<boolean>(false);
  const [openParceiros, setOpenParceiros] = useState<boolean>(false);
  const [idUsuario, setIdUsuario] = useState<number>(0);
  const [openSearch, setOpenSearch] = useState(false);
  const [pesquisaKey, setPesquisaKey] = useState<string>('Email');
  const [pesquisaValue, setPesquisaValue] = useState<string>('');
  const [parceiros, setParceiros] = useState<Parceiro[]>([]);
  const [parceirosVinculados, setParceirosVinculados] = useState<Parceiro[]>([]);

  useEffect(() => {
    load();
  }, [])

  const load = async () => {
    try {
      await loadParceiros();
      await loadLogedUser();
    } catch (err) {
      console.log(err);
    }
  }

  const handlerChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => setBloqueioUsuario(event.target.checked);
  const handlerNomeChange = (e: ChangeEvent<HTMLInputElement>) => setNomeUsuario(e.target.value);
  const handlerTelefoneChange = (e: ChangeEvent<HTMLInputElement>) => setTelefoneUsuario(e.target.value);
  const handlerEmailChange = (e: ChangeEvent<HTMLInputElement>) => setEmailUsuario(e.target.value);
  const handlerFiledCountChange = (e: ChangeEvent<HTMLInputElement>) => setFalhasfoneUsuario(+e.target.value);
  const handlerSenhaChange = (e: ChangeEvent<HTMLInputElement>) => setSenhaUsuario(e.target.value);
  const handlerPesquisaValueChange = (e: ChangeEvent<HTMLInputElement>) => setPesquisaValue(e.target.value);
  const handlerPesquisaKeyChange = (e: SelectChangeEvent<typeof pesquisaKey>) => setPesquisaKey(e.target.value);

  const loadParceiros = async () => {
    let parceiros = await parceiroDataSet.ListarTodos('');
    setParceiros(parceiros);
  }

  const loadLogedUser = async () => {
    let _usuario: Usuario = JSON.parse(String(localStorage.getItem(usuarioDataSet.getKeyCach())));

    setIdUsuario(+_usuario.id);
    setNomeUsuario(_usuario.nome);
    setEmailUsuario(_usuario.email);
    setTelefoneUsuario(_usuario.telefone);
    setFalhasfoneUsuario(+_usuario.qtdeFalhasAcesso);
    setPerfilUsuario(+_usuario.regras[0].id);
    setBloqueioUsuario(_usuario.bloqueado);
  }

  const create = async () => {
    if (!emailUsuario)
      throw t("pages.user.text.requiredEmailField");

    if (!nomeUsuario)
      throw t("pages.user.text.requiredNameField");

    if (!senhaUsuario)
      throw t("pages.user.text.requiredPasswordField");

    if (parceirosVinculados.length < 1 && perfilUsuario != 1)
      throw t("pages.user.text.requiredPartnetField");

    var re = /\S+@\S+\.\S+/;
    if (re.test(emailUsuario.trim()) === false)
      throw t("pages.user.text.invalidEmailField");

    let usuario = new Usuario();
    let regra = new Regra();

    regra.id = perfilUsuario;

    usuario.nome = nomeUsuario;
    usuario.email = emailUsuario;
    usuario.telefone = telefoneUsuario;
    usuario.passwordHash = senhaUsuario;
    usuario.bloqueado = bloqueioUsuario;
    usuario.regras = [regra]
    usuario.apelido = '';

    await usuarioDataSet.Adicionar(usuario);
  }

  const update = async () => {
    if (!emailUsuario)
      throw t("pages.user.text.requiredEmailField");

    if (!nomeUsuario)
      throw t("pages.user.text.requiredNameField");

    if (parceirosVinculados.length < 1 && perfilUsuario != 1)
      throw t("pages.user.text.requiredPartnetField");

    var re = /\S+@\S+\.\S+/;
    if (re.test(emailUsuario.trim()) === false)
      throw t("pages.user.text.invalidEmailField");

    let usuario = new Usuario();
    let regra = new Regra();

    regra.id = perfilUsuario;

    usuario.id = idUsuario;
    usuario.nome = nomeUsuario;
    usuario.telefone = telefoneUsuario;
    usuario.bloqueado = bloqueioUsuario;
    usuario.regras = [regra]
    usuario.apelido = '';
    usuario.parceiros = parceirosVinculados;

    // console.log('usuario: ', usuario);

    await usuarioDataSet.Atualizar(usuario);

    let usuarioLogado: Usuario = JSON.parse(String(localStorage.getItem(usuarioDataSet.getKeyCach())));
    if (usuario.id = usuarioLogado.id) {
      let usuarioLogadoAtualizado = await usuarioDataSet.RecuperarPorId(+usuarioLogado.id);
      localStorage.setItem(usuarioDataSet.getKeyCach(), JSON.stringify(usuarioLogadoAtualizado));
    }

  }

  const handleSave = async () => {
    try {

      if (idUsuario > 0)
        await update();
      else
        await create();

      confirmAlert({
        title: t("pages.user.text.saveUser"),
        message: t("pages.user.text.successSaveUser"),
        buttons: [{
          label: "Ok", onClick: async () => {
            setPesquisaKey('Email');
            setPesquisaValue(emailUsuario);
            await handleSearch('Email', emailUsuario);
          }
        }]
      });

    } catch (error: any) {
      confirmAlert({
        title: t("pages.user.text.saveUser"),
        message: error,
        buttons: [{ label: "Ok", onClick: () => { } }]
      });
    }
  }

  const handleNewuser = async () => {
    setIdUsuario(0);
    setNomeUsuario('');
    setEmailUsuario('');
    setTelefoneUsuario('');
    setFalhasfoneUsuario(0);
    setPerfilUsuario(1);
    setBloqueioUsuario(false);
    setSenhaUsuario('');
    setParceirosVinculados([]);
  }

  const handleDelete = async () => {
    try {
      let usuario = new Usuario();
      usuario.id = idUsuario;

      await usuarioDataSet.Apagar(usuario);

      confirmAlert({
        title: t("pages.user.text.deleteUser"),
        message: t("pages.user.text.successDeleteUser"),
        buttons: [{
          label: "Ok", onClick: async () => {
            await loadLogedUser();
          }
        }]
      });

    } catch (error: any) {
      confirmAlert({
        title: t("pages.user.text.deleteUser"),
        message: error,
        buttons: [{ label: "Ok", onClick: () => { } }]
      });
    }
  }

  const handleSearch = async (pesquisaKey: string, pesquisaValue: string | number) => {

    try {
      let user: Usuario | undefined = new Usuario();
      switch (pesquisaKey) {
        case 'Id':
          user = await usuarioDataSet.RecuperarPorId(+pesquisaValue);
          break;
        case 'Email':
          user = await usuarioDataSet.RecuperarPorEmail(pesquisaValue + '');
          break;
        default:
          throw t("pages.user.text.searchFieldNotRecognized")
      }

      if (!user)
        throw `${t("pages.user.text.userWith")} ${pesquisaKey} = ${pesquisaValue} ${t("pages.user.text.notFounded")}`

      setIdUsuario(+user.id);
      setNomeUsuario(user.nome);
      setEmailUsuario(user.email);
      setBloqueioUsuario(user.bloqueado);
      setSenhaUsuario('***');
      setTelefoneUsuario(user.telefone);
      setFalhasfoneUsuario(+user.qtdeFalhasAcesso);
      setPerfilUsuario(+user.regras[0]?.id);
      setParceirosVinculados(user.parceiros);

    } catch (error: any) {
      confirmAlert({
        title: t("pages.user.text.searchUser"),
        message: error,
        buttons: [{ label: "Ok", onClick: () => { } }]
      });
    } finally {
      setOpenSearch(false);
    }
  };

  const handleGeneratePass = () => {
    let randomString = Math.random().toString(36).slice(-8);
    setSenhaUsuario(randomString);
  }

  return (
    <div className="container">
      <React.Fragment>
        < UsuarioTopo />
        <div className="containerToolbar">
          <Tooltip title={t("pages.user.text.newUser")}>
            <span>
              <IconButton onClick={handleNewuser} disabled={!user.isRoot}>
                <NewIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t("pages.user.text.userPartners")}>
            <span>
              <IconButton onClick={() => {

                if (perfilUsuario == 1) {
                  confirmAlert({
                    title: t("pages.user.text.userPartners"),
                    message: t("pages.user.text.userRootWarning"),
                    buttons: [{ label: t("pages.user.text.understand"), onClick: () => { } }]
                  });
                } else {
                  setOpenParceiros(true)
                }

              }} disabled={!user.isRoot}>
                <GroupIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t("pages.user.text.userDataUpdate")}>
            <span>
              <IconButton onClick={handleSave}>
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t("pages.user.text.userDataDelete")}>
            <span>
              <IconButton onClick={handleDelete} disabled={!user.isRoot}>
                <EraseIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t("pages.user.text.preSelectedFieldsSearch")}>
            <span>
              <IconButton aria-label="Buscar" onClick={() => setOpenSearch(true)} disabled={!user.isRoot} >
                <SearchIcon />
              </IconButton>
            </span>
          </Tooltip>
        </div>
        <div className="insiderContainer">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={3}>
              <TextField
                required
                id="nome"
                name="nome"
                label={t("common.name")}
                fullWidth
                variant="outlined"
                value={nomeUsuario}
                onChange={handlerNomeChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                disabled={idUsuario > 0}
                required
                id="email"
                name="email"
                label={t("common.email")}
                fullWidth
                variant="outlined"
                value={emailUsuario}
                onChange={handlerEmailChange}
              />
            </Grid>
            <Grid item container xs={12} sm={3}>
              <Grid item xs={10}>
                <TextField
                  id="password"
                  name="password"
                  label={t("common.password")}
                  type="password"
                  autoComplete="current-password"
                  fullWidth
                  variant="outlined"
                  value={senhaUsuario}
                  onChange={handlerSenhaChange}
                  disabled={idUsuario > 0}
                />
              </Grid>
              <Grid item xs={2}>
                <Tooltip title={t("pages.user.text.generateRandomPassword")}>
                  <span>
                    <IconButton disabled={idUsuario > 0} sx={{ marginTop: '5px', marginLeft: '5px' }} size="large" onClick={handleGeneratePass}>
                      <KeyIcon />
                    </IconButton>
                  </span>
                </Tooltip>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                id="telefone"
                name="telefone"
                label={t("common.phone")}
                fullWidth
                variant="outlined"
                value={telefoneUsuario}
                onChange={handlerTelefoneChange}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                id="falha"
                name="falha"
                label={t("pages.user.text.accessFails")}
                fullWidth
                variant="outlined"
                value={falhasUsuario}
                onChange={handlerFiledCountChange}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <SelRegras setPerfilUsuario={setPerfilUsuario} idPerfil={perfilUsuario} disabled={!user.isRoot} />
            </Grid>
            <Grid item xs={12} sm={3} alignSelf="center">
              <FormControlLabel
                value="bottom"
                control={<Switch
                  checked={bloqueioUsuario}
                  onChange={handlerChangeSwitch}
                  inputProps={{ "aria-label": "controlled" }}
                />}
                label={bloqueioUsuario ? t("pages.user.text.lockedForLogin") : t("pages.user.text.unlockedForLogin")}
                labelPlacement="bottom"
              />
            </Grid>
          </Grid>
        </div>
        <div>
          <Dialog
            disableEscapeKeyDown
            open={openSearch}
            fullWidth={true}
          >
            <DialogTitle>{t("pages.user.text.selectFieldandValueToSearch")}</DialogTitle>
            <DialogContent>
              <Box
                component="form"
                sx={{ display: "flex", flexWrap: "wrap" }}
              >
                <FormControl sx={{ m: 1, width: 200 }}>
                  <InputLabel htmlFor="demo-dialog-native">{t("common.field")}</InputLabel>
                  <Select
                    native
                    value={pesquisaKey}
                    onChange={handlerPesquisaKeyChange}
                    input={
                      <OutlinedInput
                        label={t("common.fields")}
                        id="demo-dialog-native"
                        fullWidth={true}
                      />
                    }
                  >
                    <option value={"Id"}>{t("common.id")}</option>
                    <option value={"Email"} selected>{t("common.email")}</option>
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, width: 320 }}>
                  <TextField
                    id="valor"
                    name="Valor"
                    label={t("common.value")}
                    fullWidth
                    variant="outlined"
                    value={pesquisaValue}
                    onChange={handlerPesquisaValueChange}
                  />
                </FormControl>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenSearch(false)}>{t("common.cancel")}</Button>
              <Button onClick={() => handleSearch(pesquisaKey, pesquisaValue)}>{t("common.ok")}</Button>
            </DialogActions>
          </Dialog>
        </div>
      </React.Fragment>
      <ParceiroModal openDialog={openParceiros} setOpenDialog={setOpenParceiros} parceiros={parceiros} parceirosVinculados={parceirosVinculados} setParceirosVinculados={setParceirosVinculados} />
    </div>
  );
};
